import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import confetti from 'canvas-confetti';
import celebration from "../../../images/thumb.png";
import { Rating } from 'react-simple-star-rating';
import { useNavigate } from 'react-router-dom';
import { Review_api } from '../../../redux/authslice';

const Modalstar = ({ show, onHide, onFeedbackClick, quizz, rating, onRating, dispatch }) => {
    const navigate = useNavigate();

    const handlecongass = () => {
        confetti({
            particleCount: 50,
            spread: 40,
            origin: { y: 0.4 },
            zIndex: 9999
        });
        dispatch(Review_api({ navigate, quizz, dispatch }))
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="md"
            backdrop="static"
            keyboard={false}
            dialogClassName="custom">
            <Modal.Header closeButton onClick={() => navigate("/history")} style={{ border: "none" }}>
            </Modal.Header>
            <Modal.Title id="example-modal-sizes-title-sm">
                <div style={{ display: "flex", alignItems: 'center', justifyContent: 'center' }}>
                    <img src={celebration} alt="Celebration" style={{ width: "25%" }} />
                </div>
            </Modal.Title>
            <Modal.Body style={{
                textAlign: 'center',
                fontSize: "20px",
                color: "#62636C",
                fontWeight: "600"
            }}>
                <div style={{ marginBottom: "10px" }}> Are you enjoying our<br />app so far?</div>
                <div style={{ marginBottom: "10px" }}>
                    <Rating
                        onClick={onRating}
                        ratingValue={rating}
                    />
                </div>
            </Modal.Body>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Button disabled={quizz?.ratings == "0"} className='set_btn1' style={{ width: "40%" }} size='sm' onClick={handlecongass}>
                    Yes!
                </Button>
            </div>
            <Modal.Footer style={{
                border: "none",
                display: "flex",
                justifyContent: "center",
                fontSize: "12px",
                color: "#62636C",
                fontWeight: 500
            }}>
                <span onClick={onFeedbackClick} style={{ cursor: 'pointer' }}>No, I have feedback</span>
            </Modal.Footer>
        </Modal>
    );
};

export default Modalstar;